import { ArrowRightLong, Button } from '@baseline/ui';
import styles from './toolCalcLinkCard.module.scss';
import { cx } from 'class-variance-authority';

type ToolCalcLinkCardProps = {
  image?: string;
  href: string;
  header: string;
  description: string;
};

export default function ToolCalcLinkCard({
  image,
  href,
  header,
  description
}: ToolCalcLinkCardProps) {
  return (
    <a
      href={href}
      className={cx(styles.toolCalcLinkCard, image && styles.featured)}
    >
      {image && <img className={styles.image} src={image} alt={header} />}
      <h3 className={styles.header}>{header}</h3>
      <p className={styles.description}>{description}</p>
      <Button className={styles.button} size="icon" colorScheme="tertiary">
        <ArrowRightLong />
      </Button>
    </a>
  );
}
